<script setup lang="ts">
import { ClovyrLogo } from '@clovyr/bed';
</script>

<template>
  <div class="header">
    <div class="container">
      <div class="row">
        <div class="grid__col">
          <router-link to="/" class="logo"><ClovyrLogo /></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
:deep(.clovyr-logo) {
  width: 120px;
}

.header {
  position: absolute;
  margin-top: 4rem;
  width: 100%;

  .container {
    max-width: 1140px;

    .logo {
      display: block;
      margin-left: 1rem;
    }
  }
}
</style>
